import { type Guard, type UserCredentialsCode } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';

import { useCredentialsBaseHandler } from './../hooks/useCredentialsBaseHandler';

/**
 * Guard that checks if a given credential is granted and what action to do in case it's denied.
 *
 * @param {Object} params - The parameters for the guard.
 * @param {UserCredentialsCode|UserCredentialsCode[]} params.credentialCodes - Refers to either a unique credential code or an array of credential codes to check.
 *
 * @returns {Guard} The guard with the GuardResult
 */
export const CredentialGuard = (credentialCodes: Array<UserCredentialsCode> | UserCredentialsCode): Guard => {
	return function useCredentialGuard() {
		const { back } = useRouter();

		const { onDenied, status } = useCredentialsBaseHandler({
			credentialCodes,
			onDismiss: back
		});

		return {
			onDenied,
			status
		};
	};
};
